import React from 'react';
import { ContainerTexto, TitleContainer, Text, FixedAnchor, } from '../styles';
import { VideoPlayer } from 'components/_REFACTORED/VideoPlayer';

import video from "../../../assets/video/coleta.mp4"
import { Anchor } from 'antd';

const Coleta: React.FC = () => {

  const { Link } = Anchor
  return (
    <>
      <ContainerTexto>
        <TitleContainer id="coleta-inicio">Coletas no CD</TitleContainer>
        <VideoPlayer videoFile={video} />
        <Text>
          Aqui o usuário poderá realizar o agendamento de uma coleta no centro de distribuição.
        </Text>

      </ContainerTexto>

      <FixedAnchor>
        <Link title="Início" href='#coleta-inicio' />

      </FixedAnchor>
    </>
  );
};

export default Coleta;
